@if (isDesktop$ | async) {
  <campus-navigation-rail
    [activeRouterLink]="activeRouterLink$ | async"
    [items]="navigationItems$ | async"
    class="[ flex-1 ] flex"
    (itemClick)="onNavClick($event)"
    data-cy="navigation-rail"
    >
  </campus-navigation-rail>
} @else {
  <campus-navigation-drawer
    class="[ flex-1 ]"
    [activeRouterLink]="activeRouterLink$ | async"
    [items]="navigationItems$ | async"
    data-cy="navigation-drawer"
    >
  </campus-navigation-drawer>
}


@if (hasAppShellDarkModePermission$ | async) {
  <campus-switch
    (valueChange)="onThemeChange($event)"
    withIcons
    selectedIcon="moon"
    unselectedIcon="sun"
  ></campus-switch>
}
